/* OZ homepage reviews (A/B theme, 20 Oct 2026).
   The LAI review grid (customer photo cards) is folded away under the review carousel. A "Load more reviews" button
   sits under the carousel; clicking it swaps the carousel for the grid. The grid then shows more reviews and keeps
   LAI's own "Load more" button for the rest. Blocks are found by their template block ids (suffix match). */
(function () {
  if (window.OZHomeReviews) return;
  window.OZHomeReviews = true;
  var SECTION = '[id$="__34e6a8e1-3474-4f07-9125-37f3de71e34f"]';
  var CAROUSEL = '[id$="lai_product_reviews_card_carousel_WbLP9V"]';
  var GRID = '[id$="lai_product_reviews_card_grid_M7JD3i"]';
  var EXTRA_PAGES = 2; // after opening, ask the grid for 2 more pages (LAI's own Load more), then leave its button for the rest

  function moreButton(grid) {
    var els = grid.querySelectorAll('button, a, [role="button"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.offsetParent !== null && /load more|show more|more reviews/i.test(el.textContent || '')) return el;
    }
    return null;
  }

  function loadPages(grid, left) {
    if (left <= 0) return;
    var tries = 0;
    (function wait() {
      var b = moreButton(grid);
      if (b && !b.disabled) {
        b.click();
        setTimeout(function () { loadPages(grid, left - 1); }, 1200);
      } else if (++tries < 10) {
        setTimeout(wait, 300);
      }
    })();
  }

  function init() {
    var sec = document.querySelector(SECTION);
    if (!sec) return;
    var carousel = sec.querySelector(CAROUSEL);
    var grid = sec.querySelector(GRID);
    if (!carousel || !grid || sec.querySelector('.oz-reviews-more')) return;
    var wrap = document.createElement('div');
    wrap.className = 'oz-reviews-more';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'oz-reviews-more__btn';
    btn.textContent = 'Load more reviews';
    btn.setAttribute('aria-expanded', 'false');
    wrap.appendChild(btn);
    carousel.parentNode.insertBefore(wrap, carousel.nextSibling);
    btn.addEventListener('click', function () {
      sec.classList.add('oz-reviews-open');
      btn.setAttribute('aria-expanded', 'true');
      // let the review widget re-measure now that it is visible
      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
      loadPages(grid, EXTRA_PAGES);
      if (grid.scrollIntoView) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
